import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  text: 'I used to repeat the same stretching sequences every week because I had nothing else ready. Now I have six complete volumes at my fingertips and my classes are completely different. My students notice it every single session.',
  author: 'Sarah M.',
  role: 'Stretching & Flexibility Instructor',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80'
}, {
  text: "I had some routines for specific body parts but nothing organized or progressive. Stretching Ready gave me a complete system I can actually rely on. It's the first time I feel truly prepared walking into every class.",
  author: 'James L.',
  role: 'Yoga & Mobility Coach',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80'
}, {
  text: 'The special populations volume alone was worth everything. I finally know how to work with my senior clients and my post-injury students without second-guessing myself every time. This is the guide I needed two years ago.',
  author: 'Laura P.',
  role: 'Wellness & Stretching Coach',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80'
}, {
  text: 'The bonuses are a goldmine on their own. The verbal cue library and the session builder cards save me hours every single week. I look more professional in front of my students and it shows in my retention.',
  author: 'Daniel R.',
  role: 'Group Fitness Instructor',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80'
}, {
  text: 'I finally stopped improvising. The themed sessions in Volume 6 completely changed how I structure my weekly programming. My regular students are making progress they never made before.',
  author: 'Emma T.',
  role: 'Pilates & Stretching Instructor',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=200&q=80'
}, {
  text: 'As a newer instructor this gave me the confidence I was missing. Everything is organized, progressive and ready to use. It feels like having a senior mentor in my pocket every single class.',
  author: 'Marcus B.',
  role: 'Certified Stretching Coach',
  avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=200&q=80'
}];
export function TestimonialsSection() {
  return <section className="py-12 sm:py-24 bg-white relative overflow-hidden" data-id="element-215">
      {/* Decorative background */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-50 to-white" data-id="element-216" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[20rem] bg-brand-500/5 blur-[100px] rounded-full" data-id="element-217" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-218">
        <div className="mx-auto max-w-3xl text-center mb-8 sm:mb-16" data-id="element-219">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-3 sm:mb-4" data-id="element-220">
            WHAT INSTRUCTORS ARE ALREADY SAYING
          </h2>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-1.5 sm:gap-2 text-sm sm:text-lg font-medium text-slate-600" data-id="element-221">
            <div className="flex text-amber-400" data-id="element-222">
              {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 sm:h-5 sm:w-5 fill-current" data-id="element-223" />)}
            </div>
            <span data-id="element-224">4.9/5 — Trusted by instructors worldwide 🌍</span>
          </div>
        </div>

        <div className="flex overflow-x-auto snap-x snap-mandatory gap-4 pb-4 sm:pb-0 sm:grid sm:gap-8 sm:grid-cols-2 lg:grid-cols-3 hide-scrollbar [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-225">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative rounded-2xl bg-slate-50 p-6 sm:p-8 ring-1 ring-slate-100 min-w-[85vw] sm:min-w-0 snap-center hover:shadow-lg transition-all" data-id="element-226">
              <Quote className="absolute top-4 sm:top-6 right-4 sm:right-6 h-6 w-6 sm:h-8 sm:w-8 text-slate-200" data-id="element-227" />
              <div className="flex text-amber-400 mb-3 sm:mb-4" data-id="element-228">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-3.5 w-3.5 sm:h-4 sm:w-4 fill-current" data-id="element-229" />)}
              </div>
              <p className="text-sm sm:text-base text-slate-700 leading-relaxed mb-4 sm:mb-6 relative z-10" data-id="element-230">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-231">
                <img src={testimonial.avatar} alt={testimonial.author} loading="lazy" className="h-11 w-11 sm:h-12 sm:w-12 flex-none rounded-full object-cover ring-2 ring-white shadow-sm" data-id="element-232" />
                <div data-id="element-233">
                  <p className="font-bold text-slate-900 text-sm sm:text-base" data-id="element-234">
                    {testimonial.author}
                  </p>
                  <p className="text-xs sm:text-sm text-slate-500" data-id="element-235">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}